import { collection, getDocs, query, where } from "firebase/firestore";
import React from "react";
import { db } from "../../firebase";

const CheckDuplicateEmployeeID = (empId, SchoolID) => {
  console.log(empId, SchoolID);
  if (empId && SchoolID) {
    const UserRef = collection(db, "Users");

    const q = query(
      UserRef,
      where("SchoolID", "==", SchoolID),
      where("UserType", "==", "teacher"),
      where("AdditionalDetails.EmployeeID", "==", empId)
    );

    return getDocs(q).then((querySnapshot) => {
      console.log(querySnapshot.size);
      return querySnapshot.size;
    });
  }
};

export default CheckDuplicateEmployeeID;
